import React, { useContext, useRef } from 'react';
import * as Styled from 'src/components/OxAccordion/OxAccordion.styled';
import { PortableText } from '@portabletext/react';

export type TAccordionItem = {
    title: string;
    descriptionBlocks?: any;
    openingMultipleItems: boolean;
};

type TProps = TAccordionItem & {
    componentIsReady: boolean;
    portableTextComponents?: Record<string, unknown>;
};

export const OxAccordionItem = ({
    title,
    descriptionBlocks,
    openingMultipleItems,
    portableTextComponents
}: TProps): JSX.Element => {
    return (
        <Styled.AccordionDetails name={openingMultipleItems ? 'openingMultipleItems' : ''}>
            <Styled.AccordionSummary>
                {title}
                <Styled.AccordionClosed>+</Styled.AccordionClosed>
                <Styled.AccordionOpened>-</Styled.AccordionOpened>
            </Styled.AccordionSummary>
            <Styled.AccordionContent>
                <PortableText value={descriptionBlocks} components={portableTextComponents} />
            </Styled.AccordionContent>
        </Styled.AccordionDetails>
    );
};
